class CountdownBarComponent extends HTMLElement {
  connectedCallback() {
    const mode = this.dataset.mode || 'date';
    const loopMs = Math.max(1, parseInt(this.dataset.loopMinutes, 10) || 60) * 60 * 1000;

    let target = null;
    if (mode !== 'loop') {
      const endAttr = this.dataset.end;
      if (!endAttr) return;
      target = new Date(endAttr).getTime();
      if (Number.isNaN(target)) return;
    }

    const daysEl = this.querySelector('[data-days]');
    const daysWrap = this.querySelector('[data-days-wrap]');
    const hoursEl = this.querySelector('[data-hours]');
    const minutesEl = this.querySelector('[data-minutes]');
    const secondsEl = this.querySelector('[data-seconds]');
    const timerEl = this.querySelector('[data-countdown-timer]');
    const labelEl = this.querySelector('.countdown-bar__label');
    const hideOnExpiry = this.dataset.hideOnExpiry === 'true';
    const expiredText = this.dataset.expiredText || '';

    const pad = (value) => String(value).padStart(2, '0');

    const tick = () => {
      let diff;

      if (mode === 'loop') {
        // Loop mode: restarts automatically every N minutes.
        diff = loopMs - (Date.now() % loopMs);
      } else {
        diff = target - Date.now();

        if (diff <= 0) {
          clearInterval(this._interval);
          const section = this.closest('.countdown-bar');

          if (hideOnExpiry) {
            if (section) section.style.display = 'none';
            return;
          }

          if (timerEl) timerEl.style.display = 'none';
          if (labelEl && expiredText) labelEl.textContent = expiredText;
          return;
        }
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (daysWrap) daysWrap.style.display = days > 0 ? '' : 'none';
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    };

    tick();
    this._interval = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    if (this._interval) clearInterval(this._interval);
  }
}

if (!customElements.get('countdown-bar-component')) {
  customElements.define('countdown-bar-component', CountdownBarComponent);
}
